<template>
    <div>
        <b-card title="Confirm Check Out Details" :class="{ translucent: !!loadingText }">
            <form @submit.prevent="clockOut()" @keydown="form.clearError($event.target.name)">
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Claimant" label-for="time">
                            <b-form-input v-model="shift.client.name" readonly></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <h5>Activities Performed</h5>

                        <b-row class="mb-2" v-for="activity in activities" :key="activity.id">
                            <b-col cols="6">{{ activity.name }}</b-col>
                            <b-col cols="6">
                                <b-form-select name="test" v-model="form.activities[activity.id]">
                                    <option value="">---</option>

                                    <option v-for="option in activity.responses" :key="option.id" :value="option.name" v-text="option.name" />
                                </b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col lg="12">
                        <b-form-group label="Did the client fall today?" label-class="h5">
                            <b-form-radio-group id="client_fall" v-model="form.client_fall" name="client_fall">
                                <b-form-radio value="1">Yes</b-form-radio>
                                <b-form-radio value="0">No</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    
                    <b-col lg="12">
                        <b-form-group label="Was there a change in the client's condition today?" label-class="h5">
                            <b-form-radio-group id="client_condition" v-model="form.client_condition" name="client_condition">
                                <b-form-radio value="1">Improved</b-form-radio>
                                <b-form-radio value="-1">Declined</b-form-radio>
                                <b-form-radio value="0">No Change</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <shift-hospital-stay-input
                    v-if="shift.client.carrier.hospital_stays_enabled"
                    @hospital-stay-updated="updateHospitalStayFields"
                    :hospital_stays_enhanced_flow="shift.client.carrier.hospital_stays_enhanced_flow"
                    :max="checked_in_date"
                    :cols="12"
                />

                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Additional Comments" label-class="h5">
                            <b-textarea id="caregiver_comments" v-model="form.caregiver_comments" rows="2"></b-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12">
                        <b-form-group>
                            <signature-pad v-model="form.signature"></signature-pad>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col lg="12">
                        <b-button id="complete-clock-out" variant="success" type="submit">Complete Check-out</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-alert variant="secondary" show>I confirm that the information reported about this visit is true, complete, and accurate.</b-alert>
                    </b-col>
                </b-row>
            </form>
        </b-card>
        <b-card class="loading-card" v-show="!!loadingText">
            <div class="text-center">
                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                <p>
                    {{ loadingText }}
                </p>
            </div>
        </b-card>
    </div>
</template>

<script>
    import FormatsDates from "../mixins/FormatsDates";

    export default {
        mixins: [FormatsDates],

        props: {
            'shift': {},
            'activities': Array,
            // 'carePlanActivityIds': Array,
        },

        data() {
            return {
                form: new Form({
                    caregiver_comments: null,
                    // mileage: 0,
                    // other_expenses: 0.00,
                    latitude: null,
                    longitude: null,
                    activities: [],
                    // caregiver_injury: 0,
                    // issue_text: null,
                    // other_expenses_desc: null,
                    signature: null,

                    client_fall: 0,
                    client_condition: 0,
                    hospital_stay: 0,

                    still_in_hospital       : 0,

                    hospital_stay_from_date : null,
                    hospital_stay_to_date   : null,
                }),

                checked_in_date: '',
                showManual: false,
                time: null,
                clockInTime: null,
                loadingText: null,
            }
        },

        mounted() {
            this.setTimes();
        },

        methods: {
            updateHospitalStayFields(emitted) {
                this.form.hospital_stay = emitted.hospitalStay;
                this.form.still_in_hospital = emitted.stillInHospital;
                this.form.hospital_stay_from_date = emitted.fromDate;
                this.form.hospital_stay_to_date = emitted.toDate;
            },
            showLoading(text = 'Loading..') {
                this.loadingText = text;
            },

            hideLoading() {
                this.loadingText = null;
            },

            clockOut() {
               
                if (!navigator.geolocation) {
                    alert('Location services are not supported on your device.');
                    return;
                }
                if (!confirm('Are you sure you wish to check out?')) {
                    return;
                }
                this.showLoading('Waiting for location..');
                navigator.geolocation.getCurrentPosition(position => {
                    this.form.latitude = position.coords.latitude;
                    this.form.longitude = position.coords.longitude;
                    console.log(position.coords);
                    this.hideLoading();
                    this.submitForm();
                }, error => {
                    this.form.latitude = null;
                    this.form.longitude = null;
                    console.log(error);
                    this.hideLoading();
                    this.submitForm();
                }, {
                    enableHighAccuracy: true,
                    timeout: 5000,
                    maximumAge: 0
                });
            },

            async submitForm() {
              try {
                this.showLoading('Checking out..');
                const url = `/clock-out/${this.shift.id}`;
                await this.form.post(url);
                window.location = '/schedule?clocked_out=1'
              } catch (err) {
                console.log(err);
              } finally {
                this.hideLoading();
              }
            },

            setTimes() {
                this.time = this.formatTime();
                this.clockInTime = this.formatTimeFromUTC(this.shift.checked_in_time);
                this.checked_in_date = this.convertDateYmdToMdy(this.shift.checked_in_time);
                setInterval(() => this.time = this.formatTime(), 1000 * 60)
            }
        },
    }
</script>


<style>
    .loading-card {
        z-index: 10000;
        position: absolute;
        top: 20%;
        width: 250px;
        left: 50%;
        margin-left: -125px;
    }

    .translucent {
        opacity: .5;
    }

    input.classic {
        left: auto!important;
        opacity: 1!important;
    }

    label.h5 {
        line-height: 18px;
        font-size: 16px;
        font-weight: 400;
    }
</style>